import styled from 'styled-components';
import { hexToRgbA } from 'utils/colors';

export const StyledButtonBlock = styled.span`
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 0 2px ${({ theme }) => hexToRgbA(theme.color.baliHai, 0.25)};
`;

export const StyledButton = styled.span`
  font-size: 17px;
  line-height: 1;
  color: ${({ theme }) => theme.color.baliHai};
  user-select: none;
`;
